import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";


function AsaasCard() {
  const [st, setSt] = useState(null);
  const [env, setEnv] = useState("sandbox");
  const [key, setKey] = useState("");
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState({ type: "", text: "" });
  const load = async () => {
    try {
      const r = await api.get("/commercial-portal/integrations/asaas");
      setSt(r?.data || null);
      setEnv(r?.data?.environment || "sandbox");
    } catch { setMsg({ type: "err", text: "Não foi possível carregar a configuração do Asaas." }); }
  };
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (env === "production" && st?.environment !== "production" &&
        !window.confirm("Mudar o Asaas para PRODUÇÃO? As próximas cobranças serão reais.")) return;
    setBusy("save"); setMsg({ type: "", text: "" });
    try {
      await api.put("/commercial-portal/integrations/asaas", { environment: env, api_key: key.trim() });
      setKey(""); await load();
      setMsg({ type: "ok", text: "Configuração do Asaas salva." });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setMsg({ type: "err", text: typeof d === "string" ? d : "Não foi possível salvar." });
    } finally { setBusy(""); }
  };
  const test = async () => {
    setBusy("test"); setMsg({ type: "", text: "" });
    try {
      const r = await api.post("/commercial-portal/integrations/asaas/test", {});
      setMsg({ type: r?.data?.ok ? "ok" : "err", text: r?.data?.message || "" });
    } catch { setMsg({ type: "err", text: "Falha ao testar." }); } finally { setBusy(""); }
  };
  const field = "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-[15px] text-slate-800 outline-none transition focus:border-[#5b3bf0] focus:ring-2 focus:ring-[#5b3bf0]/15";
  const label = "mb-1 block text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500";
  if (!st) return null;
  return (
    <div className="mt-5 rounded-[28px] bg-white px-6 py-6 shadow-xl sm:px-8">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="text-[18px] font-bold text-[#1b1464]">Asaas (cobranças)</div>
        <span className={`rounded-full px-3 py-1 text-[12px] font-bold ${st.environment === "production" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
          Ativo: {st.environment === "production" ? "Produção" : "Sandbox (teste)"}
        </span>
      </div>
      {msg.text && (
        <div className={`mt-4 rounded-xl px-4 py-2.5 text-[14px] font-semibold ${msg.type === "ok" ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{msg.text}</div>
      )}
      <div className="mt-5 grid gap-5">
        <div>
          <span className={label}>Ambiente</span>
          <div className="flex gap-2">
            {[["sandbox", "Sandbox (teste)"], ["production", "Produção"]].map(([v, t]) => (
              <button key={v} type="button" onClick={() => setEnv(v)}
                className={`rounded-xl px-4 py-2.5 text-[14px] font-bold transition ${env === v ? "bg-[#1b1464] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{t}</button>
            ))}
          </div>
        </div>
        <div>
          <span className={label}>Chave de API {env === st.environment && st.key_set ? `(salva: ••••${st.key_last4})` : "(cole a chave deste ambiente)"}</span>
          <input type="password" autoComplete="off" className={field} value={key} onChange={(e) => setKey(e.target.value)}
            placeholder={env === st.environment && st.key_set ? "Deixe em branco para manter a atual" : "Cole a chave de API gerada no Asaas"} />
          <div className="mt-1 text-[12px] text-slate-400">No site do Asaas: Integrações → Chaves de API. A chave de produção começa com $aact_prod.</div>
        </div>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={save} disabled={!!busy} className="rounded-xl bg-[#5b3bf0] px-6 py-2.5 text-[14px] font-bold text-white hover:bg-[#4a2ee0] disabled:opacity-50">{busy === "save" ? "Salvando..." : "Salvar"}</button>
          <button type="button" onClick={test} disabled={!!busy} className="rounded-xl border border-[#5b3bf0]/25 bg-white px-5 py-2.5 text-[14px] font-bold text-[#5b3bf0] hover:bg-[#f4f1ff] disabled:opacity-50">{busy === "test" ? "Testando..." : "Testar conexão"}</button>
        </div>
      </div>
    </div>
  );
}

export default function CommercialIntegrations() {
  const [cfg, setCfg] = useState(null);
  const [env, setEnv] = useState("sandbox");
  const [token, setToken] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [signerOn, setSignerOn] = useState(false);
  const [signerEmail, setSignerEmail] = useState("");
  const [signerName, setSignerName] = useState("");
  const [asaasOn, setAsaasOn] = useState(false);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState({ type: "", text: "" });

  const load = async () => {
    try {
      const r = await api.get("/commercial-portal/integrations/zapsign");
      const d = r?.data || {};
      setCfg(d);
      setEnv(d.environment || "sandbox");
      setTemplateId(d.template_id || "");
      setSignerOn(Boolean(d.signer_enabled));
      setSignerEmail(d.signer_email || "");
      setSignerName(d.signer_name || "");
      setAsaasOn(Boolean(d.asaas_enabled));
    } catch (e) {
      setMsg({ type: "err", text: e?.response?.status === 403 ? "Apenas o usuário master acessa as integrações." : "Não foi possível carregar as integrações." });
    }
  };
  useEffect(() => { load(); }, []);

  const err = (e, fb) => {
    const d = e?.response?.data?.detail;
    setMsg({ type: "err", text: typeof d === "string" ? d : fb });
  };

  const save = async () => {
    if (env === "production" && cfg?.environment !== "production" &&
        !window.confirm("Mudar para PRODUÇÃO? Os próximos contratos serão enviados pelo ZapSign oficial e terão validade jurídica.")) return;
    setBusy("save"); setMsg({ type: "", text: "" });
    try {
      await api.put("/commercial-portal/integrations/zapsign", {
        environment: env, api_token: token, template_id: templateId.trim(),
        signer_enabled: signerOn, signer_email: signerEmail.trim(), signer_name: signerName.trim(),
        asaas_enabled: asaasOn,
      });
      setToken("");
      await load();
      setMsg({ type: "ok", text: "Configurações salvas." });
    } catch (e) { err(e, "Não foi possível salvar."); } finally { setBusy(""); }
  };

  const test = async () => {
    setBusy("test"); setMsg({ type: "", text: "" });
    try {
      const r = await api.post("/commercial-portal/integrations/zapsign/test", {});
      const d = r?.data || {};
      setMsg({ type: d.ok ? "ok" : "err", text: d.message || (d.ok ? "Conexão OK." : "Falha na conexão.") });
    } catch (e) { err(e, "Falha ao testar."); } finally { setBusy(""); }
  };

  const rotate = async () => {
    if (!window.confirm("Gerar nova chave do webhook? A chave antiga deixa de funcionar e você precisa atualizar o endereço no ZapSign.")) return;
    setBusy("rotate"); setMsg({ type: "", text: "" });
    try {
      await api.post("/commercial-portal/integrations/zapsign/rotate-webhook", {});
      await load();
      setMsg({ type: "ok", text: "Nova chave gerada. Copie o endereço do webhook e cole no ZapSign." });
    } catch (e) { err(e, "Não foi possível gerar a chave."); } finally { setBusy(""); }
  };

  const copy = async (t) => { try { await navigator.clipboard.writeText(t); setMsg({ type: "ok", text: "Copiado." }); } catch { /* ignore */ } };

  const field = "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-[15px] text-slate-800 outline-none transition focus:border-[#5b3bf0] focus:ring-2 focus:ring-[#5b3bf0]/15";
  const label = "mb-1 block text-[12px] font-bold uppercase tracking-[0.12em] text-slate-500";
  const card = "mt-5 rounded-[28px] bg-white px-6 py-6 shadow-xl sm:px-8";

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1b1464] via-[#3423b8] to-[#5b3bf0] px-4 py-8 sm:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="rounded-[28px] bg-white px-6 py-6 shadow-xl sm:px-8">
          <a href="/commercial-portal" className="text-[13px] font-bold text-[#5b3bf0] hover:underline">← Voltar ao Portal Comercial</a>
          <div className="mt-3 text-[12px] font-bold uppercase tracking-[0.18em] text-[#5b3bf0]">Configurações</div>
          <h1 className="mt-1 text-[30px] font-extrabold text-[#1b1464]">Integrações</h1>
          <p className="mt-2 text-[15px] text-slate-500">Assinatura eletrônica dos contratos (ZapSign). As alterações valem na hora, sem republicar.</p>
        </div>

        {msg.text && (
          <div className={`mt-4 rounded-2xl px-5 py-3 text-[14px] font-semibold ${msg.type === "ok" ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{msg.text}</div>
        )}

        {cfg && (
          <>
            <div className={card}>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="text-[18px] font-bold text-[#1b1464]">ZapSign</div>
                <span className={`rounded-full px-3 py-1 text-[12px] font-bold ${cfg.environment === "production" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                  Ativo: {cfg.environment === "production" ? "Produção" : "Sandbox (teste)"}
                </span>
              </div>
              <div className="mt-5 grid gap-5">
                <div>
                  <span className={label}>Ambiente</span>
                  <div className="flex gap-2">
                    {[["sandbox", "Sandbox (teste)"], ["production", "Produção"]].map(([v, t]) => (
                      <button key={v} type="button" onClick={() => setEnv(v)}
                        className={`rounded-xl px-4 py-2.5 text-[14px] font-bold transition ${env === v ? "bg-[#1b1464] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{t}</button>
                    ))}
                  </div>
                </div>
                <div>
                  <span className={label}>Token da API {cfg.token_set ? `(salvo: ••••${cfg.token_last4})` : "(não configurado)"}</span>
                  <input type="password" autoComplete="off" className={field} placeholder={cfg.token_set ? "Deixe em branco para manter o atual" : "Cole o token gerado no ZapSign"} value={token} onChange={(e) => setToken(e.target.value)} />
                  <div className="mt-1 text-[12px] text-slate-400">O token de sandbox e o de produção são diferentes. Ao trocar o ambiente, cole o token correspondente.</div>
                </div>
                <div>
                  <span className={label}>ID do modelo</span>
                  <input className={field} value={templateId} onChange={(e) => setTemplateId(e.target.value)} placeholder="ex.: 4bf0d4ef-93ee-4320-b38b-c4128b3cb2ed" />
                </div>
                <div className="rounded-2xl border border-slate-200 p-4">
                  <label className="flex items-center gap-2 text-[15px] font-semibold text-slate-700">
                    <input type="checkbox" checked={signerOn} onChange={(e) => setSignerOn(e.target.checked)} />
                    A Simpler também assina cada contrato
                  </label>
                  <div className="mt-1 text-[12px] text-slate-400">Desligado: o contrato é concluído e o acesso liberado assim que o cliente assina.</div>
                  {signerOn && (
                    <div className="mt-3 grid gap-3 sm:grid-cols-2">
                      <div><span className={label}>Nome de quem assina</span><input className={field} value={signerName} onChange={(e) => setSignerName(e.target.value)} /></div>
                      <div><span className={label}>E-mail de quem assina</span><input className={field} value={signerEmail} onChange={(e) => setSignerEmail(e.target.value)} /></div>
                    </div>
                  )}
                </div>
                <div className="rounded-2xl border border-slate-200 p-4">
                  <label className="flex items-center gap-2 text-[15px] font-semibold text-slate-700">
                    <input type="checkbox" checked={asaasOn} onChange={(e) => setAsaasOn(e.target.checked)} />
                    Gerar cobranças automáticas no Asaas (adesão e mensalidade)
                  </label>
                  <div className="mt-1 text-[12px] text-slate-400">Só funciona com o ZapSign em Produção. Desligado: o contrato é assinado e o acesso é liberado, mas a cobrança fica para ser gerada manualmente.</div>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button type="button" onClick={save} disabled={!!busy} className="rounded-xl bg-[#5b3bf0] px-6 py-2.5 text-[14px] font-bold text-white hover:bg-[#4a2ee0] disabled:opacity-50">{busy === "save" ? "Salvando..." : "Salvar"}</button>
                  <button type="button" onClick={test} disabled={!!busy} className="rounded-xl border border-[#5b3bf0]/25 bg-white px-5 py-2.5 text-[14px] font-bold text-[#5b3bf0] hover:bg-[#f4f1ff] disabled:opacity-50">{busy === "test" ? "Testando..." : "Testar conexão"}</button>
                </div>
              </div>
            </div>

            <AsaasCard />

            <div className={card}>
              <div className="text-[18px] font-bold text-[#1b1464]">Webhook</div>
              <p className="mt-1 text-[14px] text-slate-500">Cole este endereço no ZapSign, em Configurações → Integração → Webhooks, com o evento "Todos".</p>
              {cfg.webhook_url ? (
                <div className="mt-3 flex flex-col gap-2 sm:flex-row">
                  <input readOnly className={`${field} font-mono text-[13px]`} value={cfg.webhook_url} />
                  <button type="button" onClick={() => copy(cfg.webhook_url)} className="rounded-xl bg-[#1b1464] px-5 py-2.5 text-[14px] font-bold text-white">Copiar</button>
                </div>
              ) : (
                <div className="mt-3 text-[14px] font-semibold text-amber-700">Nenhuma chave configurada. Gere uma chave abaixo.</div>
              )}
              <button type="button" onClick={rotate} disabled={!!busy} className="mt-3 rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-[14px] font-bold text-slate-700 hover:bg-slate-50 disabled:opacity-50">
                {busy === "rotate" ? "Gerando..." : "Gerar nova chave do webhook"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
